import React, { useState, useRef, useEffect } from "react";
import { AgGridReact } from "ag-grid-react";
import SweetAlert from "react-bootstrap-sweetalert";
import redirectURL from "../redirectURL";
import Select from 'react-select';

export default function TransitDaysBufferMaster() {
    const gridRef = useRef();

    const decipher = (salt) => {
        const textToChars = (text) => text.split("").map((c) => c.charCodeAt(0));
        const applySaltToChar = (code) =>
            textToChars(salt).reduce((a, b) => a ^ b, code);

        return (encoded) =>
            (encoded || "")
                .match(/.{1,2}/g)
                ?.map((hex) => parseInt(hex, 16))
                .map(applySaltToChar)
                .map((charCode) => String.fromCharCode(charCode))
                .join("") || "";
    };

    const decode = decipher("Z744cRBHYjQTsI6cOlNaUKbuEQF6MiEr");
    const localStorageEmail = localStorage.getItem("email");

    const [sourcePincode, setSourcePincode] = useState("");
    const [destPincode, setDestPincode] = useState("");
    const [rowData, setRowData] = useState([]);

    const [show, setShow] = useState(false);
    const [basicType, setBasicType] = useState("");
    const [basicTitle, setBasicTitle] = useState("");

    const categoryValues = ["Zonal", "National", "Regional"];
    const [entities, setEntities] = useState([]);
    const [showloader, setshowloader] = useState("show-n");
    const [resetKey, setResetKey] = useState(0);

    const [showModal, setShowModal] = useState(false);
    const emptyForm = {
        consigner_pincode: "",
        consignee_pincode: "",
        entity: [],
        category: "",
        buffer_days: ""
    };

    const [modalForm, setModalForm] = useState(emptyForm);
    const [editingIndex, setEditingIndex] = useState(null);

    const [modalErrors, setModalErrors] = useState({});

    const clearFieldError = (field) => {
        setModalErrors((prev) => ({ ...prev, [field]: "" }));
    };

    const loadEntities = async () => {
        try {
            const resp = await redirectURL.post("/consignments/allEntityData", {});
            const records = resp?.data || [];
            const opts = [...new Set(records.map((x) => x.entity))]
                .filter(Boolean)
                .sort()
                .map((x) => ({ label: x, value: x }));
            setEntities(opts);
        } catch (err) {
            console.error("Entity load error", err);
        }
    };

    const loadData = async (skipValidation = false) => {
        setshowloader("show-m");

        if (!skipValidation) {
            if (!sourcePincode && !destPincode) {
                setBasicType("error");
                setBasicTitle(
                    "Please enter Source Pincode or Destination Pincode"
                );
                setShow(true);
                setshowloader("show-n");
                return;
            }
        }

        const req = {
            consigner_pincode: sourcePincode || null,
            consignee_pincode: destPincode || null
        };

        try {
            const resp = await redirectURL.post(
                "/consignments/getTransitDaysBuffer",
                req
            );

            if (resp?.data?.status === "success") {
                let records = resp.data.records || [];
                records = records.map((r) => ({
                    ...r,
                    _id: r._id ? r._id.toString() : null
                }));

                setRowData(records);
                setTimeout(
                    () => gridRef.current?.api?.setRowData(records),
                    50
                );
            } else {
                setRowData([]);
                setTimeout(
                    () => gridRef.current?.api?.setRowData([]),
                    50
                );
            }
        } catch (err) {
            setRowData([]);
            setTimeout(() => gridRef.current?.api?.setRowData([]), 50);
        }

        setshowloader("show-n");
    };

    useEffect(() => {
        loadEntities();
        loadData(true);
    }, []);
    useEffect(() => {
        if (sourcePincode === "" && destPincode === "") {
            loadData(true);
        }
    }, [sourcePincode, destPincode, resetKey]);


    const resetFilters = () => {
        setSourcePincode("");
        setDestPincode("");
        setRowData([]);

        setResetKey(prev => prev + 1);
    };


    const openAddModal = () => {
        setModalForm({ ...emptyForm, entity: [] });
        setEditingIndex(null);
        setModalErrors({});
        setShowModal(true);
    };

    const openEditModal = (params) => {
        const d = params.data;

        setModalForm({
            consigner_pincode: d.consigner_pincode || "",
            consignee_pincode: d.consignee_pincode || "",
            entity: Array.isArray(d.entity)
                ? d.entity
                : d.entity
                    ? d.entity.split(",")
                    : [],
            category: d.category || "",
            buffer_days: d.buffer_days ? String(d.buffer_days) : ""
        });

        setEditingIndex(params.rowIndex);
        setModalErrors({});
        setShowModal(true);
    };

    const closeModal = () => {
        setShowModal(false);
        setEditingIndex(null);
        setModalErrors({});
    };
    const validateModalForm = () => {
        const f = modalForm;
        let errors = {};

        if (!f.consigner_pincode)
            errors.consigner_pincode = "Source Pincode is required";
        else if (f.consigner_pincode.length !== 6)
            errors.consigner_pincode = "Source Pincode must be 6 digits";

        if (!f.consignee_pincode)
            errors.consignee_pincode = "Destination Pincode is required";
        else if (f.consignee_pincode.length !== 6)
            errors.consignee_pincode = "Destination Pincode must be 6 digits";

        if (
            f.consigner_pincode &&
            f.consignee_pincode &&
            f.consigner_pincode === f.consignee_pincode
        ) {
            errors.consignee_pincode =
                "Source and Destination Pincodes cannot be the same";
        }

        if (!f.entity || f.entity.length === 0) {
            errors.entity = "At least one entity is required";
        }

        if (!f.category) errors.category = "Category is required";

        if (!f.buffer_days)
            errors.buffer_days = "Buffer Days is required";
        else if (!/^\d{1,3}$/.test(f.buffer_days))
            errors.buffer_days = "Buffer Days must be numeric";

        setModalErrors(errors);
        return Object.keys(errors).length === 0;
    };

    const saveRecordToServer = async (record) => {
        const decodedEmail = decode(localStorageEmail) || "system";

        const payload = {
            record,
            unique_id: record._id || null,
            email: decodedEmail
        };

        const resp = await redirectURL.post(
            "/consignments/saveTransitDaysBuffer",
            payload
        );
        return resp.data;
    };


    const handleModalSave = async () => {
        if (!validateModalForm()) return;

        const f = modalForm;

        const newRow = {
            _id: editingIndex !== null ? rowData[editingIndex]._id : null,
            consigner_pincode: f.consigner_pincode,
            consignee_pincode: f.consignee_pincode,
            entity: f.entity,
            category: f.category,
            buffer_days: f.buffer_days
        };

        const newEntities = Array.isArray(newRow.entity)
            ? newRow.entity
            : newRow.entity.split(",");

        const sameRows = rowData.filter(
            (r, idx) =>
                idx !== editingIndex &&
                r.consigner_pincode === newRow.consigner_pincode &&
                r.consignee_pincode === newRow.consignee_pincode
        );

        let existingEntities = [];
        sameRows.forEach(r => {
            if (Array.isArray(r.entity)) {
                existingEntities = existingEntities.concat(r.entity);
            } else if (typeof r.entity === "string") {
                existingEntities = existingEntities.concat(r.entity.split(","));
            }
        });

        if (sameRows.some(r => {
            const stored = Array.isArray(r.entity) ? r.entity : r.entity.split(",");
            return JSON.stringify(stored.sort()) === JSON.stringify(newEntities.sort());
        })) {
            return setModalErrors({
                entity: "This Source, Destination & Entity combination already exists!"
            });
        }
        const duplicateEntity = newEntities.find(ent =>
            existingEntities.includes(ent)
        );

        if (duplicateEntity) {
            return setModalErrors({
                entity: `Entity '${duplicateEntity}' already exists for these pincodes!`
            });
        }
        try {
            setshowloader("show-m");

            const result = await saveRecordToServer(newRow);

            if (result.status === "success") {
                setBasicType("success");
                setBasicTitle("Saved Successfully!");
                setShow(true);

                closeModal();
                loadData(true);
            } else {
                setBasicType("error");
                setBasicTitle(result.message || "Save failed");
                setShow(true);
            }
        } catch (err) {
            setBasicType("error");
            setBasicTitle("Server error while saving");
            setShow(true);
        } finally {
            setshowloader("show-n");
        }
    };
    const resetModalForm = () => {
        setModalForm({
            consigner_pincode: "",
            consignee_pincode: "",
            entity: [],
            category: "",
            buffer_days: ""
        });

        setModalErrors({});
    };
    const columnDefs = [
        {
            headerName: "",
            width: 100,
            editable: false,
            cellRenderer: (params) => {
                return (
                    <div
                        style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            height: "100%",
                            width: "100%"
                        }}
                    >
                        <button
                            className="btn btn-primary"
                            style={{
                                width: "70px",
                                height: "30px",
                                fontSize: "13px",
                                padding: "0px"
                            }}
                            onClick={() => openEditModal(params)}
                        >
                            Edit
                        </button>
                    </div>
                );
            }
        },
        { headerName: "Source Pincode", field: "consigner_pincode", width: 160 },
        {
            headerName: "Destination Pincode",
            field: "consignee_pincode",
            width: 180
        },
        { headerName: "Entity", field: "entity", width: 160 },
        { headerName: "Category", field: "category", width: 150 },
        { headerName: "Buffer Days", field: "buffer_days", width: 140 }
    ];

    const defaultColDef = {
        resizable: true,
        sortable: true,
        filter: true,
        editable: false
    };
    return (
        <div className="container-fluid">
            <SweetAlert
                show={show}
                type={basicType}
                title={basicTitle}
                onConfirm={() => setShow(false)}
            />

            <div className="card">
                <div className="card-body">
                    <div className="row align-items-end">
                        <div className="col-xl-2 col-lg-2 form-group">
                            <label>Source Pincode</label>
                            <input
                                type="text"
                                className="form-control"
                                maxLength={6}
                                value={sourcePincode}
                                onChange={(e) =>
                                    setSourcePincode(
                                        e.target.value.replace(/\D/g, "")
                                    )
                                }
                            />
                        </div>

                        <div className="col-xl-2 col-lg-2 form-group">
                            <label>Destination Pincode</label>
                            <input
                                type="text"
                                className="form-control"
                                maxLength={6}
                                value={destPincode}
                                onChange={(e) =>
                                    setDestPincode(
                                        e.target.value.replace(/\D/g, "")
                                    )
                                }
                            />
                        </div>

                        <div
                            className="col-xl-4 col-lg-4 form-group"
                            style={{ paddingTop: "28px" }}
                        >
                            <button
                                className="btn btn-success"
                                onClick={() => loadData(false)}
                            >
                                Get Data
                            </button>
                            &nbsp;
                            <button className="btn btn-default" onClick={resetFilters}>
                                Reset
                            </button>
                        </div>

                        <div
                            className="col-xl-4 col-lg-4 d-flex justify-content-end form-group"
                            style={{ paddingTop: "28px" }}
                        >
                            <button className="btn btn-primary" onClick={openAddModal}>
                                + Add Row
                            </button>
                        </div>
                    </div>

                    <div
                        className="ag-theme-balham mt-3"
                        style={{ height: "500px", width: "100%" }}
                    >
                        <AgGridReact
                            ref={gridRef}
                            rowData={rowData}
                            columnDefs={columnDefs}
                            defaultColDef={{
                                ...defaultColDef,
                                resizable: true,
                                sortable: true,
                                filter: true,
                                cellStyle: {
                                    display: "flex",
                                    alignItems: "center",
                                    fontSize: "14px"
                                }
                            }}
                            rowHeight={32}
                            pagination={true}
                            paginationPageSize={20}
                            sideBar={{
                                toolPanels: [
                                    {
                                        id: "columns",
                                        labelDefault: "Columns",
                                        iconKey: "columns",
                                        toolPanel: "agColumnsToolPanel"
                                    },
                                    {
                                        id: "filters",
                                        labelDefault: "Filters",
                                        iconKey: "filter",
                                        toolPanel: "agFiltersToolPanel"
                                    }
                                ],
                                position: "right",
                                defaultToolPanel: ""
                            }}
                        />
                    </div>
                </div>
            </div>

            {showModal && (
                <>
                    <div className="modalOverlay" onClick={closeModal}></div>

                    <div
                        className="rightModal"
                        style={{
                            position: "fixed",
                            top: 0,
                            right: 0,
                            width: "420px",
                            height: "100vh",
                            background: "#fff",
                            zIndex: 9999,
                            padding: "20px",
                            overflowY: "auto",
                            boxShadow: "-3px 0 10px rgba(0,0,0,0.2)"
                        }}
                    >
                        <button
                            className="close"
                            onClick={closeModal}
                            style={{
                                position: "absolute",
                                top: "15px",
                                right: "15px",
                                fontSize: "26px",
                                fontWeight: "700",
                                border: "none",
                                background: "transparent",
                                cursor: "pointer"
                            }}
                        >
                            &times;
                        </button>

                        <div
                            style={{
                                backgroundColor: "#1F6F8B",
                                color: "white",
                                padding: "12px 0",
                                textAlign: "center",
                                fontSize: "18px",
                                fontWeight: "600",
                                position: "relative",
                                margin: "-20px -20px 20px -20px"
                            }}
                        >
                            {editingIndex === null
                                ? "Add Transit Days Buffer"
                                : "Edit Transit Days Buffer"}

                            <button
                                onClick={closeModal}
                                style={{
                                    position: "absolute",
                                    right: "15px",
                                    top: "50%",
                                    transform: "translateY(-50%)",
                                    width: "32px",
                                    height: "32px",
                                    borderRadius: "50%",
                                    border: "none",
                                    backgroundColor: "#0B3C5D",
                                    color: "white",
                                    fontSize: "16px",
                                    fontWeight: "700",
                                    cursor: "pointer",
                                    padding: 0,
                                    lineHeight: "32px",
                                    textAlign: "center"
                                }}
                            >
                                X
                            </button>
                        </div>

                        <label>
                            Source Pincode <span style={{ color: "red" }}>*</span>
                        </label>
                        <input
                            type="text"
                            className="form-control mb-1"
                            maxLength={6}
                            value={modalForm.consigner_pincode}
                            onChange={(e) => {
                                const v = e.target.value.replace(/\D/g, "");
                                setModalForm((p) => ({
                                    ...p,
                                    consigner_pincode: v
                                }));
                                clearFieldError("consigner_pincode");
                            }}
                        />
                        {modalErrors.consigner_pincode && (
                            <div style={{ color: "red", marginBottom: "10px" }}>
                                {modalErrors.consigner_pincode}
                            </div>
                        )}

                        <label>
                            Destination Pincode <span style={{ color: "red" }}>*</span>
                        </label>
                        <input
                            type="text"
                            className="form-control mb-1"
                            maxLength={6}
                            value={modalForm.consignee_pincode}
                            onChange={(e) => {
                                const v = e.target.value.replace(/\D/g, "");
                                setModalForm((p) => ({
                                    ...p,
                                    consignee_pincode: v
                                }));
                                clearFieldError("consignee_pincode");
                            }}
                        />
                        {modalErrors.consignee_pincode && (
                            <div style={{ color: "red", marginBottom: "10px" }}>
                                {modalErrors.consignee_pincode}
                            </div>
                        )}

                        <label>Entity <span style={{ color: "red" }}>*</span></label>

                        <Select
                            isMulti
                            options={entities.map(ent => ({
                                label: ent.label,
                                value: ent.value
                            }))}
                            value={
                                Array.isArray(modalForm.entity)
                                    ? modalForm.entity.map(v => ({ label: v, value: v }))
                                    : []
                            }
                            onChange={(selected) => {
                                const values = selected.map(item => item.value);

                                setModalForm(prev => ({
                                    ...prev,
                                    entity: values
                                }));

                                clearFieldError("entity");
                            }}
                            className="mb-1"
                            styles={{
                                container: base => ({ ...base, width: "100%" }),
                                menu: base => ({ ...base, zIndex: 99999 }),
                            }}
                        />

                        {modalErrors.entity && (
                            <div style={{ color: "red", marginBottom: "10px" }}>
                                {modalErrors.entity}
                            </div>
                        )}
                        <label>
                            Category <span style={{ color: "red" }}>*</span>
                        </label>
                        <select
                            className="form-control mb-1"
                            value={modalForm.category}
                            onChange={(e) => {
                                setModalForm((p) => ({
                                    ...p,
                                    category: e.target.value
                                }));
                                clearFieldError("category");
                            }}
                        >
                            <option value="" disabled hidden>Select Category</option>
                            {categoryValues.map((c) => (
                                <option key={c} value={c}>
                                    {c}
                                </option>
                            ))}
                        </select>
                        {modalErrors.category && (
                            <div style={{ color: "red", marginBottom: "10px" }}>
                                {modalErrors.category}
                            </div>
                        )}

                        <label>
                            Buffer Days <span style={{ color: "red" }}>*</span>
                        </label>
                        <input
                            type="text"
                            className="form-control mb-1"
                            value={modalForm.buffer_days}
                            onChange={(e) => {
                                const v = e.target.value.replace(/\D/g, "");
                                if (v.length <= 3) {
                                    setModalForm((p) => ({
                                        ...p,
                                        buffer_days: v
                                    }));
                                }
                                clearFieldError("buffer_days");
                            }}
                        />
                        {modalErrors.buffer_days && (
                            <div style={{ color: "red", marginBottom: "10px" }}>
                                {modalErrors.buffer_days}
                            </div>
                        )}

                        <div
                            className="mt-3"
                            style={{
                                display: "flex",
                                justifyContent: "flex-end",
                                alignItems: "center"
                            }}
                        >
                            <button
                                className="btn"
                                style={{
                                    width: "100px",
                                    height: "40px",
                                    fontSize: "15px",
                                    marginRight: "4px",
                                    backgroundColor: "#a6a7a8ff", borderColor: "#a6a7a8ff",
                                    borderRadius: "5px"
                                }}
                                onClick={resetModalForm}
                            >
                                Reset
                            </button>
                            <button
                                className="btn btn-secondary"
                                style={{
                                    width: "120px",
                                    height: "40px",
                                    marginRight: "6px"
                                }}
                                onClick={closeModal}
                            >
                                Cancel
                            </button>

                            <button
                                className="btn btn-success"
                                style={{
                                    width: "120px",
                                    height: "40px",
                                    borderRadius: "5px"
                                }}
                                onClick={handleModalSave}
                            >
                                Save
                            </button>
                        </div>
                    </div>
                </>
            )}

            <div className={"dataLoadpage " + showloader}></div>
            <div className={"dataLoadpageimg " + showloader}>
                <div className="loader-box">
                    <div className="loader-box">
                        <div className="rotate dashed colored"></div>
                    </div>
                </div>
            </div>
        </div>
    );
}